(function (root, factory) {
  'use strict';
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else {
    root.MSProjectPlannerRequestHandoff = factory(root);
    root.MSProjectPlannerRequestHandoff.receive();
  }
})(typeof window !== 'undefined' ? window : null, function (browser) {
  'use strict';
  const pendingKey = 'ms-planner-request-pending';
  const lifetime = 10 * 60 * 1000;
  function read(key) {
    try {
      const value = JSON.parse(browser.sessionStorage.getItem(key));
      return value && Date.now() - value.at >= 0 && Date.now() - value.at < lifetime ? value : null;
    } catch (_) { return null; }
  }
  function remove(key) { browser.sessionStorage.removeItem(key); }
  function prepare() {
    try {
      // Identify this Planner request on Shopify's native response page.
      browser.sessionStorage.setItem(pendingKey, JSON.stringify({at: Date.now()}));
      return true;
    } catch (_) { return false; }
  }
  function receive() {
    const errorPage = browser.document.querySelector('[data-ms-planner-error-response]');
    const pending = read(pendingKey);
    if (errorPage) {
      if (pending) {
        errorPage.hidden = false;
        browser.document.querySelector('#MainContent').hidden = true;
      } else errorPage.remove();
      return; // An error response never performs a successful handoff.
    }
    if (!pending || !browser.document.querySelector('[data-ms-planner-confirmed-success]')) return;
    try {
      // Consume the attempt before leaving; errors never reach this branch.
      remove(pendingKey);
      browser.location.replace('https://mulchandstuff.com/pages/landscape-material-project-planner-access');
    } catch (_) { /* No redirect if the pending attempt cannot be retired. */ }
  }
  return Object.freeze({prepare, receive});
});
